export default "__VITE_ASSET__BlEVUGPS__"